import { render } from "./ProgramMultimediaEditItemPane.vue?vue&type=template&id=60a439f4&scoped=true&ts=true"
import script from "./ProgramMultimediaEditItemPane.vue?vue&type=script&lang=ts"
export * from "./ProgramMultimediaEditItemPane.vue?vue&type=script&lang=ts"

import "./ProgramMultimediaEditItemPane.vue?vue&type=style&index=0&id=60a439f4&scoped=true&lang=css"

import exportComponent from "C:\\Ventla new admin\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-60a439f4"]])

export default __exports__